import React from "react";
import Cx from "classnames";

import Modal from "../Modal";
import * as styles from "./ExportSpreadsheet.module.scss";
import FieldList from "./FieldList";

// TODO -- maybe define this in the Rails database or codebase
const fieldSchema = [
  {
    name: "title",
    label: "Title",
  },
  {
    name: "year",
    label: "Year",
  },
  {
    name: "medium",
    label: "Media",
  },
  {
    name: "dimensions",
    label: "Dimensions",
  },
  {
    name: "subtype",
    label: "Type",
  },
  {
    name: "value",
    label: "Retail price",
  },
  {
    name: "pricing_notes",
    label: "Pricing notes",
  },
  {
    name: "edition",
    label: "Edition",
  },
  {
    name: "artist_override",
    label: "Artist override",
  },
  {
    name: "artist_name",
    label: "Artist",
  },
  {
    name: "status",
    label: "Status",
  },
  {
    name: "location",
    label: "Location",
  },
  {
    name: "inventory",
    label: "Inventory #",
  },
  {
    name: "description",
    label: "Description",
  },
  {
    name: "links",
    label: "Links",
    lineBreak: true,
  },
  {
    name: "provenance",
    label: "Provenance",
  },
  {
    name: "condition",
    label: "Condition report",
  },
  {
    name: "cost",
    label: "Cost description",
  },
  {
    name: "total_cost",
    label: "Total cost",
  },
  {
    name: "notes",
    label: "Notes",
    columnBreak: true,
  },
  {
    name: "images_url_list",
    label: "Images",
  },
  {
    name: "docs_url_list",
    label: "Documents",
  },
  {
    name: "videos_url_list",
    label: "Video files",
  },
  {
    name: "audios_url_list",
    label: "Audio files",
    lineBreak: true,
  },
  {
    name: "event_assocs_title",
    label: "Event titles",
  },
  {
    name: "press_assocs_title",
    label: "Press titles",
  },
  {
    name: "set_assocs_title",
    label: "Set titles",
  },
  {
    name: "publication_assocs_title",
    label: "Publication titles",
  },
  {
    name: "sale_assocs_title",
    label: "Sales",
  },
];

const defaultState = {
  open: false,
  items: [],
  selectedFields: ["title", "year", "medium", "dimensions", "artist_override"],
  selectAllResults: false,
  status: "",
  error: "",
};

const selectedFieldsGallery = [
  "title",
  "year",
  "medium",
  "dimensions",
  "artist_name",
];

const getDefaultState = (role) => {
  const stateOnLoad = defaultState;

  if (role === "gallery") {
    stateOnLoad.selectedFields = selectedFieldsGallery;
  }

  return stateOnLoad;
};

const getFieldSchema = (role) => {
  if (role === "gallery") {
    return fieldSchema.filter((field) => field.name !== "artist_override");
  }

  return fieldSchema.filter((field) => field.name !== "artist_name");
};

const Layout = ({ open, onClose, children }) => {
  return (
    <Modal isOpen={open} onClose={onClose}>
      {children}
    </Modal>
  );
};

export default class ExportSpreadsheet extends React.Component {
  componentDidMount() {
    const { role } = this.props;
    window.addEventListener(
      "openExportSpreadsheetReactComponent",
      this.handleOpen
    );

    this.setState(getDefaultState(role));
  }

  componentDidUpdate(prevProps, prevState) {
    // get information about the selected items
    const { items } = this.state;
    const newItems = [];

    document
      .querySelectorAll(".bulk-actions-checkbox:checked")
      .forEach((element) => {
        const { id, classname } = element.dataset;
        if (classname === "Work") newItems.push({ id, classname });
      });

    if (JSON.stringify(items) !== JSON.stringify(newItems)) {
      this.setState({ items: newItems });
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = (e) => {
    e.stopPropagation();
    this.setState(defaultState);
  };

  handleSelectAllResults = () => {
    this.setState({ selectAllResults: true });
  };

  handleSelectField = (e) => {
    const { selectedFields } = this.state;
    const { fieldName } = e.target.dataset;
    const newSelectedFields = selectedFields.includes(fieldName)
      ? selectedFields.filter((field) => field !== fieldName)
      : selectedFields.concat([fieldName]);

    this.setState({ selectedFields: newSelectedFields });
  };

  handleSelectAll = () => {
    const { role } = this.props;
    this.setState({
      selectedFields: getFieldSchema(role).map((field) => field.name),
    });
  };

  handleSelectNone = () => {
    this.setState({ selectedFields: [] });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { selectedFields, selectAllResults, error } = this.state;
    const { allIds } = this.props;
    const checkedIds = [];

    if (error) this.setState({ error: "" });
    this.setState({ status: "loading" });

    $("tr.row-work .bulk-actions-checkbox:checked").each(function (index, el) {
      checkedIds.push($(el).attr("data-id"));
    });
    const allStarredWorkIds = allIds
      .filter((record) => record.type === "Work")
      .map((record) => record.id);

    const allWorks = selectAllResults ? allStarredWorkIds : checkedIds;

    if (!selectedFields.length || !checkedIds.length) {
      this.setState({
        error:
          "Please ensure that you have selected at least one work record and one field.",
        status: "",
      });
      return;
    }

    const data = {
      all_works: allWorks.join(","),
      all_attributes: selectedFields.join(","),
    };

    const that = this;

    $.ajax({
      method: "POST",
      url: "/export_spreadsheet",
      data,
    })
      .done((data) => {
        that.setState({ status: "success", error: "" });
      })
      .fail(function () {
        that.setState({ status: "", error: "Your request failed." });
      });
  };

  render() {
    if (!this.state) return null;

    const { open, items, selectedFields, selectAllResults, status, error } =
      this.state;
    const { allIds, email, role } = this.props;
    const selectedItems = selectAllResults ? allIds : items;
    const modalProps = { open, onClose: this.handleClose };

    if (!selectedItems.length) {
      return (
        <Layout {...modalProps}>
          <h1 className={styles.h1}>Export to spreadsheet</h1>
          <p>
            You haven't selected any work records. Please click the checkboxes
            next to the work records that you would like to export.
          </p>
        </Layout>
      );
    }

    if (status === "success") {
      return (
        <Layout {...modalProps}>
          <p className={styles.successNotice}>
            Your spreadsheet is being generated. We will email you at {email}{" "}
            when the spreadsheet is complete.
          </p>
        </Layout>
      );
    }

    let message = (
      <p>
        You have selected {selectedItems.length} work record
        {selectedItems.length === 1 ? "" : "s"}. Select the fields that you
        would like to export to a spreadsheet.
      </p>
    );

    if (allIds.length > selectedItems.length && !selectAllResults) {
      message = (
        <>
          <p>
            You have selected {selectedItems.length} work record
            {selectedItems.length === 1 ? "" : "s"}. Select the fields that you
            would like to export to a spreadsheet.
          </p>
          <p style={{ marginTop: "16px" }}>
            <a
              role="button"
              onClick={this.handleSelectAllResults}
              className={styles.selectAllButton}
            >
              Click here to select all {allIds.length} work records in this
              search result.
            </a>
          </p>
        </>
      );
    }

    return (
      <Layout {...modalProps}>
        <h1 className={styles.h1}>Export work records to spreadsheet</h1>
        {message}
        <FieldList
          fieldSchema={getFieldSchema(role)}
          selectedFields={selectedFields}
          onSelectField={this.handleSelectField}
          onSelectAll={this.handleSelectAll}
          onSelectNone={this.handleSelectNone}
        />
        <p>
          <em>
            Note: after clicking the "request spreadsheet" button you will be
            sent a link to the spreadsheet via email.
          </em>
        </p>
        <div className={styles.submitArea}>
          {!!error && <p>{error}</p>}
          <button
            onClick={this.handleSubmit}
            className={Cx(
              { [styles.buttonLoading]: status === "loading" },
              styles.submit
            )}
          >
            Request spreadsheet
          </button>
        </div>
      </Layout>
    );
  }
}
